<ui-title [title]="'Approval Requests'"></ui-title>

<ui-loading [hidden]="!requests.loading"></ui-loading>
<ui-table [hidden]="requests.loading"
		  [filters]="true"
		  [chunker]="requests.chunker" (chunked)="requests.chunkedData = $event"
		  [headers]="requests.tableHeaders"
		  #table
>
	<tr *ngFor="let d of requests.chunkedData"
	>
		<td>{{d.Type}}</td>
		<td>{{d.Reference}}</td>
		<td>{{d.CreatedDate|date}}</td>
		<td>{{d.SORUser.FirstName}} {{d.SORUser.LastName}}</td>
		<td>{{d.SORUser.Email}}</td>
		<td>{{d.StatusId}}</td>
		<td>{{d.DecisionDate|date}}</td>
		<td>
			<span style="color:grey" *ngIf="d.NeedCountersigning && !d.CounterSignedBy">Pending</span>
			<span style="color:grey; opacity: 0.5;" *ngIf="!d.NeedCountersigning">N/A</span>
			<span class="green" *ngIf="d.NeedCountersigning && d.CounterSignedBy" [matTooltip]="d.CounterSignedBy+', '+(d.CounterSignedDate|date)">Counter Signed</span>
		</td>
		<td><a [routerLink]="'/p/approval-requests/'+d.Id">Open</a></td>
	</tr>
</ui-table>

<div class="card-separator"></div>

<div class="card">
	<div class="card-header">
		New Approval Request Batch
	</div>
	<div class="card-body">
		<form (ngSubmit)="new_submit($event)">
			<div class="form-group mb-3">
				<label class="col-form-label">
					Type (e.g. Sequel_Claims_TC)
				</label>
				<div>
					<input class="form-control" [(ngModel)]="new.request.Type" name="ar-type"/>
				</div>
			</div>
			<div class="form-group mb-3">
				<label class="col-form-label">
					Reference (E.g. Quarter + Year)
				</label>
				<div>
					<input class="form-control" [(ngModel)]="new.request.Reference" name="ar-reference"/>
				</div>
			</div>
			<div class="form-group mb-3">
				<label class="col-form-label">
					Description
				</label>
				<div>
					<input class="form-control" [(ngModel)]="new.request.Description" name="ar-description"/>
				</div>
			</div>
			<div class="form-group mb-3">
				<label class="col-form-label">
					Email Subject
				</label>
				<div>
					<input class="form-control" [(ngModel)]="new.EmailSubject" name="ar-description"/>
				</div>
			</div>
			<div class="form-group mb-3">
				<label class="col-form-label">
					Email Body
				</label>
				<div>
					<input class="form-control" [(ngModel)]="new.EmailBody" name="ar-description"/>
				</div>
			</div>
			<div class="form-group mb-3">
				<label class="col-form-label">
					File
				</label>
				<div>
					<ui-uploader [parent]="self" [listVisible]="true">

					</ui-uploader>
				</div>
			</div>

			<div class="form-group mb-3">
				<label class="col-form-label">
					User list
				</label>
				<div>
					<button mat-button type="button" (click)="new_addUser()" style="position: absolute;margin-left: 410px;margin-top: 1px">
						Add User
					</button>
					<ui-input-autocompleter
						#autocompleter
						[text]="'Search User'"
						[controller]="self"
						[autocompleteDisplay]="helper_autocomplete_displaySelectedUsername"
						[searchObservable]="helper_autocomplete_search"
					></ui-input-autocompleter>

					<table class="ui-table" *ngIf="new.userList.length>0">
						<tr>
							<th>First Name</th>
							<th>Last Name</th>
							<th>Login</th>
							<th>Action</th>
						</tr>
						<tr *ngFor="let u of new.userList;index as  uIndex">
							<td>{{u.FirstName}}</td>
							<td>{{u.LastName}}</td>
							<td>{{u.Login}}</td>
							<td>
								<button type="button" (click)="userList_Remove(u,uIndex)" class="btn btn-sm btn-danger" style="font-size:10px">x</button>
							</td>
						</tr>
					</table>
				</div>
			</div>

			<div class="form-group mb-3">
				<div class="row">
					<div class="form-group">
						<label class="col-form-label">
							Approval Options
						</label>
					</div>

					<div class="form-group row">
						<div *ngFor="let r of new.options">
							<label style="margin:0" class="helper-clickable">
								<input type="checkbox" (change)="selectedOptions(r)" value="{{r}}">
								<span style="text-transform: capitalize;font-weight: normal;font-size: 14px;">&nbsp;{{r}}</span>
							</label>
						</div>
					</div>
				</div>
			</div>

			<div class="form-group mb-3">
				<div class="row">
					<div class="form-group">
						<label class="col-form-label">
							Counter Signing
						</label>
					</div>
				</div>
				<div class="row">
					<div class="form-group">
						<label style="margin:0" class="helper-clickable">
							<input type="checkbox" (change)="selectedOptionsCounterSign(new.canCounterSign,$event)" value="{{new.canCounterSign?1:0}}">
							<span style="text-transform: capitalize;font-weight: normal;font-size: 14px;">&nbsp;Mandatory</span>
						</label>
					</div>
				</div>
			</div>

			<div class="alert alert-danger" *ngIf="new.errors.length">
				<div *ngFor="let e of new.errors">{{e}}</div>
			</div>
			<div class="form-group mb-3">
				<label class="col-form-label">

				</label>
				<div>
					<ui-loading *ngIf="new.saving"></ui-loading>
					<button class="btn btn-primary" [hidden]="new.saving" type="submit">Create</button>

					{{new.userList.length}} recipients
				</div>
			</div>
		</form>


	</div>
</div>

